import type { TemplateVariableValue } from '@/questionnaire/types'

const isDate = (date: Date) => date?.getMonth
const dateToStr = (date: Date) => `${date.toISOString().split('T')[0]}`

export const getTemplateVariablesArray = (templateVariableValues: Record<string, TemplateVariableValue>) => {
  const newVariableMap = []

  for (const [code, content] of Object.entries(templateVariableValues)) {
    // account for date MultiSelectValue && DateRangeValue
    if (Array.isArray(content)) {
      newVariableMap.push({
        code,
        content: content.map(contentItem => (isDate(contentItem) ? dateToStr(contentItem) : `${contentItem}`)),
      })
      continue
    }

    // account for Date
    if (isDate(content)) {
      newVariableMap.push({
        content: dateToStr(content),
        code,
      })
      continue
    }

    // account for other data types
    if (['string', 'number', 'boolean'].includes(typeof content)) {
      newVariableMap.push({
        content: `${content}`,
        code,
      })
    }
  }

  return newVariableMap
}
